module.exports = __webpack_public_path__ + "static/media/md-link.39fd3a56.svg";